import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import { Box, Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import { useHomeUIContext } from "../HomeUIContext";

export function HomePageCalendar() {
    const homeUIContext = useHomeUIContext();
    const homeUIProps = useMemo(() => {
        return {
            data: homeUIContext.data,
        };
    }, [homeUIContext]);

    const events = homeUIProps.data
        ? homeUIProps.data.map((item) => ({
              id: item.id,
              title: item.tersedia ? "Tersedia" : "Dibooking",
              start: new Date(item.waktu_booking),
              tersedia: item.tersedia,
          }))
        : [];

    const renderEventContent = ({ event }) => {
        const waktuBooking = event.start;
        const jam = waktuBooking.getHours().toString().padStart(2, "0");
        const menit = waktuBooking.getMinutes().toString().padStart(2, "0");
        const formattedTime = `${jam}.${menit}`;

        return (
            <div
                className={`eventContent-homepage ${
                    event.extendedProps.tersedia ? "" : "booked"
                }`}
            >
                <div className="event-time">{formattedTime}</div>
                <div className="event-title">{event.title}</div>
            </div>
        );
    };

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={3}>
                    <div className="home-page-schedule-section-left">
                        <div className="home-page-schedule-section-left-content">
                            <Box className="home-page-schedule-section-left-content-vertical-line" />
                            <div className="home-page-schedule-section-left-content-title">
                                <Typography variant="h5" component="h5">
                                    Ketersediaan
                                </Typography>
                                <Typography variant="h5" component="h5">
                                    Jadwal
                                </Typography>
                            </div>
                        </div>
                        <div className="home-page-schedule-section-left-content-2">
                            <img
                                className="home-page-schedule-section-left-content-2-image"
                                src="/assets/images/example-docs.webp"
                                alt="content"
                            />
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} lg={9}>
                    <div className="home-page-schedule-section-right">
                        <FullCalendar
                            plugins={[
                                dayGridPlugin,
                                timeGridPlugin,
                                interactionPlugin,
                            ]}
                            headerToolbar={{
                                left: "prev,next today",
                                center: "title",
                                right: "dayGridMonth,timeGridWeek,timeGridDay",
                            }}
                            locale="id"
                            initialView="dayGridMonth"
                            editable={true}
                            selectable={true}
                            selectMirror={true}
                            dayMaxEvents={true}
                            weekends={true}
                            events={events}
                            eventContent={renderEventContent}
                            eventTimeFormat={{
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: false,
                            }}
                            buttonText={{
                                today: "Hari Ini",
                                month: "Bulan",
                                week: "Minggu",
                                day: "Hari",
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}
